// extracted by mini-css-extract-plugin
module.exports = {"generatePasswordButton":"GenerateButtonPassword_generatePasswordButton__K6Fnw","star":"GenerateButtonPassword_star__TWHek"};